import { style } from "@vanilla-extract/css";
import { textTruncate } from "plos/src/styles";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";
import pattern1 from "../../../../img/pattern/pattern-1-1236.png";

export const profileSummary = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const profileHeaderOuter = style({
  borderRadius: vars.radii.l,
  backgroundImage: `url(${pattern1}), linear-gradient(90deg, ${vars.colors.plBlue} 0%, ${vars.colors.plLilac} 100%)`,
  backgroundPosition: "left -9.6px top -40.8px, 0 0",
  backgroundRepeat: "no-repeat",
  backgroundSize: "147px 216px, auto",
  padding: `0 ${vars.space.s}`,
  selectors: {
    '[dir="rtl"] &': {
      backgroundImage: `url(${pattern1}), linear-gradient(270deg, ${vars.colors.plBlue} 0%, ${vars.colors.plLilac} 100%)`,
      backgroundPosition: "right -9.6px top -40.8px, 0 0",
      "@media": {
        [`screen and (min-width:${breakpoints[4]})`]: {
          backgroundPosition: "right 0px top -41px, 0 0",
        },
      },
    },
  },
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      backgroundPosition: "left 0px top -41px, 0 0",
      backgroundSize: "159px 233px, auto",
    },
  },
});

export const profileHeaderInner = style({
  display: "flex",
  gap: vars.space.l,
});

export const playerImageStyles = style({
  marginTop: "auto",
  paddingTop: "0.2rem",
  width: 94,
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      marginInlineStart: vars.space.m,
    },
  },
});

export const playerInfoStyles = style({
  display: "flex",
  flex: "0 1 auto",
  flexDirection: "column",
  justifyContent: "flex-end",
  gap: vars.space.xs,
  padding: `${vars.space.s} 0`,
  // Allow the flex container to shrink if the content is too wide
  minWidth: 0,
  color: vars.colors.onSurfaceFixed,
});

export const positionText = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading.xs,
});

export const firstNameText = style({
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.l,
});

export const secondNameText = style([
  textTruncate,
  {
    lineHeight: 1.2,
    fontSize: vars.fontSizes.heading.xl,
  },
]);

export const nameBlock = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const teamText = style({
  fontSize: vars.fontSizes.body.s,
});

export const buttonLinkWrapper = style({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: vars.space.xs,
});

export const externalLinkText = style({
  lineHeight: 1,
});
